import axios from '@/plugins/axios'

class QuestionService {
  async getQuestion() {
    const { data } = await axios.get('/sum/api/test/question').then()
    return data
  }

  async sendAnswer(answerData) {
    const formData = new FormData()
    formData.append('eId', answerData.eId)
    formData.append('answer', answerData.answer)

    const { data } = await axios
      .post('/sum/api/test/submission', formData)
      .then()
    return data
  }

  async rollbackAnswer() {
    const { data } = await axios.get('/sum/api/test/previous').then()
    return data
  }
}

export default new QuestionService()
